import React from 'react'
import ArticlesGrid from '../ArticlesGrid'
import Ad from '../Ad'

const ArticlesPage = () => {
    return (
        <div>
            <ArticlesGrid />

            <Ad />

        </div>
    )
}

export default ArticlesPage